module.exports = __webpack_public_path__ + "static/img/no-data3.fb3dd182.png";